import { put, select, takeLatest } from 'redux-saga/effects'
import { getInsuranceInformationStateSelector } from '../../insuranceInformation/selectors'
import { InsuranceInformationConstants } from '../../insuranceInformation/store/insuranceInformation.constants'
import { IInsuranceInformationState } from '../../insuranceInformation/store/insuranceInformation.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setPriorAuthorizationPayerOptions() {
  try {
    const insuranceInformationState: IInsuranceInformationState = yield select(getInsuranceInformationStateSelector)
    const { insuranceInformationList } = insuranceInformationState
    const priorAuthorizationPayerOptions = insuranceInformationList.map((insuranceStateObj) => {
      return {
        id: insuranceStateObj.key,
        name: insuranceStateObj.insuranceCarrier || insuranceStateObj.companyCoded?.name,
      }
    })
    yield put(actions.setPriorAuthorizationPayerOptions(priorAuthorizationPayerOptions))
  } catch (e) {
    yield put(throwPcrException(`setPriorAuthorizationPayerOptions() error: ${e}`))
  }
}
export function* setPriorAuthorizationPayerOptionsSaga() {
  yield takeLatest(
    [
      InsuranceInformationConstants.SET_INSURANCE_INFORMATION_LIST,
      InsuranceInformationConstants.SET_INSURANCE_INFORMATION_STATE,
      InsuranceInformationConstants.RESET_STATE,
    ],
    performWithMutexHOG,
    setPriorAuthorizationPayerOptions
  )
}
